export const changeUrl = (url: string) => {
  // @ts-ignore
  window.location = url;
};
